import React from 'react';
import { PhotoView } from 'react-photo-view';
import { Link } from 'react-router-dom';
import './Service.css'

const Service = ({food}) => {
    console.log(food);
    const shortDetails = food.details.slice(0, 100);
    return (
        <div className="card bg-base-100 shadow-xl">
            <figure className=''><PhotoView id={food._id} src={food.image} ><img id={food._id} className='food-image' src={food.image} alt="Shoes" /></PhotoView></figure>
            <div className="card-body">
                <h2 className="card-title">{food.name}</h2>
                <p>{shortDetails}...</p>
                <div className="card-actions justify-between items-center">
                    <h4 className='text-2xl font-bold text-amber-400'>{food.price}</h4>
                    <Link to={`/food/${food._id}`}><button className="btn btn-warning">Details</button></Link>
                </div>
            </div>
        </div>
    );
};

export default Service;